import {InlineDatumProps, InlineDatumReactComponentProps} from '../types';
import {ReactComponentDatum} from './ReactComponentDatum';

export const Datum = (props: InlineDatumProps) => {
  const {datum} = props;

  switch (datum.datum_type) {
    case 'react_component':
      return (
        <ReactComponentDatum {...(props as InlineDatumReactComponentProps)} />
      );
    case 'export':
      return null;
    default:
      throw new Error(`Unknown datum type: ${datum.datum_type}`);
  }
};
